const isFetchingS3Config = state => state.s3Config.loading;

const isS3ConfigError = state => state.s3Config.error;

const getS3ConfigData = state => {
    return state.s3Config.data;
};

const getS3ReservationBuyerStatusStep = state => {
    return state?.s3Config?.data?.reservations_status_steps?.buyer_steps;
};

const getS3ConfigBuyerTab = (state, lang = 'id') => {
    return state.s3Config?.data[lang]?.reservations?.buyer?.tabs;
};

const getS3ConfigBuyerStep = (state, lang = 'id') => {
    return state.s3Config?.data[lang]?.reservations?.buyer?.steps;
};

const getS3ConfigBuyerStepByLang = (state, lang) => {
    return state.s3Config?.data[lang]?.reservations?.buyer?.steps;
};

const getS3ConfigEscrowBenefits = (state, lang) => {
    return state.s3Config?.data[lang]?.strings?.escrow_benefits;
};

const getS3ConfigBuyerStrings = (state, lang = 'id', idStrings) => { // notes: this function is used by seller also, so the name is not specific to buyer
    return state.s3Config?.data[lang]?.strings[idStrings];
};

const getS3ConfigBuyerPaymentGuide = (state, lang, code) => {
    return state.s3Config?.data[lang]?.reservations?.buyer?.payment_guide[code];
};

const getS3ConfigBuyerCancellationReason = (state, lang = 'id') => {
    return state.s3Config?.data[lang]?.reservations?.buyer?.onprogress_cancellation_reasons;
};

const getStatusReservationByUrl = (state, currentUrl, lang = 'id') => {
    const tabs = getS3ConfigBuyerTab(state, lang);

    if (!tabs) {
        return [];
    }

    const matchingTab = tabs.find(tab => tab.to === currentUrl);

    return matchingTab ? matchingTab.status : [];
};

const getCardSubTextStatusReservationDisplay = (state, statusEscrow, lang = 'id') => {
    const status = getS3ConfigBuyerStep(state, lang);

    if (!status) {
        return null;
    }

    const matchingTab = status.find(item => item.key === statusEscrow);

    return matchingTab ? matchingTab.card_subtext : null;
};

const getCardTextStatusReservationDisplay = (state, statusEscrow, lang = 'id') => {
    const status = getS3ConfigBuyerStep(state, lang);

    if (!status) {
        return null;
    }

    const matchingTab = status.find(item => item.key === statusEscrow);

    return matchingTab ? matchingTab.display_name : null;
};

const getS3ConfigSellerStep = state => {
    return state.s3Config?.data?.id?.reservations?.seller?.steps;
};

const getS3ConfigSellerStatusSteps = state => {
    return state.s3Config?.data?.reservations_status_steps?.seller_steps;
};

const getS3ConfigSellerCancellationReason = state => {
    return state.s3Config?.data?.id?.reservations?.seller?.onprogress_cancellation_reasons;
};

const getS3ConfigSellerInfoSteps = state => {
    return state.s3Config?.data?.id?.reservations?.seller?.steps;
};

const getS3ConfigSellerFilters = state => {
    return state.s3Config?.data?.id?.reservations?.seller?.filters;
};

const getS3ConfigErrorMessage = (state, lang = 'id') => {
    return state.s3Config?.data[lang]?.errors;
};

const getS3ConfigDeactivateConfirmationMessage = (state, lang = 'id') => {
    return state.s3Config?.data[lang]?.strings?.deactivate_confirmation;
};

const getS3ConfigDeleteConfirmationMessage = (state, lang = 'id') => {
    return state.s3Config?.data[lang]?.strings?.delete_confirmation;
};

const getS3ConfigSoldConfirmationMessage = (state, lang = 'id') => {
    return state.s3Config?.data[lang]?.strings?.sold_confirmation;
};

const getS3ConfigSellerPosting = (state, lang = 'id') => {
    return state.s3Config?.data[lang]?.posting;
};

export {
    isFetchingS3Config,
    isS3ConfigError,
    getS3ConfigData,
    getS3ConfigBuyerTab,
    getStatusReservationByUrl,
    getS3ConfigBuyerCancellationReason,
    getCardSubTextStatusReservationDisplay,
    getCardTextStatusReservationDisplay,
    getS3ReservationBuyerStatusStep,
    getS3ConfigBuyerStepByLang,
    getS3ConfigSellerStep,
    getS3ConfigSellerCancellationReason,
    getS3ConfigEscrowBenefits,
    getS3ConfigSellerStatusSteps,
    getS3ConfigSellerInfoSteps,
    getS3ConfigSellerFilters,
    getS3ConfigBuyerStrings,
    getS3ConfigBuyerPaymentGuide,
    getS3ConfigErrorMessage,
    getS3ConfigDeactivateConfirmationMessage,
    getS3ConfigDeleteConfirmationMessage,
    getS3ConfigSoldConfirmationMessage,
    getS3ConfigSellerPosting
};
